import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyOTP } from "../api/authApi";

const VerifyOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const flowType = location.state?.flow;

  // const email = localStorage.getItem("verifyEmail");
  const phone = localStorage.getItem("resetPhone");



 useEffect(() => {
    if (!flowType) navigate("/login");
    if (flowType === "register" && !phone) navigate("/register");
    if (flowType === "forgot" && !phone) navigate("/forgot-password");
  }, [flowType, phone, navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!otp) {
      setError("OTP is required");
      return;
    }

    if (otp.length !== 6) {
      setError("OTP must be 6 digits");
      return;
    }

    try {
      if (flowType === "register") {
       
        const data = await verifyOTP({ phone, otp });
         localStorage.setItem("user", JSON.stringify(data));
        localStorage.removeItem("verifyEmail");
  localStorage.removeItem("resetPhone");
        navigate("/");
      } else {
       const data= await verifyOTP({ phone, otp });
       
        localStorage.setItem("user", JSON.stringify(data));
        navigate("/reset-password");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-[#f4ede4]">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow">
        <h2 className="text-3xl font-semibold mb-6">Verify OTP</h2>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-6">
          <input
            type="text"
            maxLength={6}
            placeholder="Enter 6-digit OTP"
            className="w-full border-b py-3 focus:outline-none"
            value={otp}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setOtp(value);
            }}
          />

          <button className="w-full bg-black text-white py-3 rounded-full">
            Verify OTP
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyOTP;